// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"st_a bhl_a bhl_r bhl_j","Photos__img":"st_b bhl_b"};